import icons from "src/config/icons";
import TagSelectorContainer from "src/components/TagsEditor/sub-components/TagSelectorContainer";
import { TagsEditorChrome, TagsEditorInlineView } from "./TagsEditor.views";
import { tagsEditorSurface } from "./TagsEditor.surface";
import { useTagsEditor } from "./useTagsEditor";
import type { TagsEditorProps } from "./tagsEditorTypes";

export type { TagsEditorProps };

const TagsEditor = (props: TagsEditorProps = {}) => {
  const TagSelector = props.components?.TagSelector ?? TagSelectorContainer;
  const editor = useTagsEditor(props);
  const View = props.inline ? TagsEditorInlineView : TagsEditorChrome;
  return (
    <View
      vm={
        {
          ...editor,
          ...tagsEditorSurface({ ...props, TagSelector, icons }),
        } as import("./tagsEditorTypes").TagsEditorViewModel
      }
    />
  );
};

export default TagsEditor;
